import axiosInstance from '@/utils/api.js'

var state = {
  telephony: [],
  telephony_numbers: []
}

var getters = {
  TELEPHONY: (state) => {
    return state.telephony
  },
  TELEPHONY_NUMBERS: (state) => {
    return state.telephony_numbers
  }
}

var mutations = {
  SET_TELEPHONY: (state, payload) => {
    state.telephony = payload
  },
  SET_TELEPHONY_NUMBERS: (state, payload) => {
    state.telephony_numbers = payload
  }
}

var actions = {
  GET_TELEPHONY: async (context, payload) => {
    let request = '/reports/telephony?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&account_id=0&accounting_period_id=0' +
    '&limit=' + payload.limit +
    '&download=' + payload.download

    if (payload.isAlternativeDate) {
      request += '&is_by_call=1'
    }

    let result = await axiosInstance.get(request, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_TELEPHONY', result.data)
    }
  },
  CLEAR_TEL: (context) => {
    context.commit('SET_TELEPHONY', [])
  },
  GET_TELEPHONY_NUMBERS: async (context, payload) => {
    let request = '/reports/tel_numbers?group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&account_id=0&user_id=0&' +
    '&limit=' + payload.limit +
    '&download=' + payload.download
    let result = await axiosInstance.get(request, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_TELEPHONY_NUMBERS', result.data)
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/telephony.js